<template>
    <div style="margin-bottom:20px;">
        <el-tag class="depend-tag"
            type="success"
            v-for="item in items"    
            :key="item.name"
            :effect="item.selected ? 'dark' : 'plain'"
            @click="selectTag(item)">
            {{ item.name }}
        </el-tag>
    </div>
</template>
<script>
export default {
    name: 'ModuleTypeEle',
    props: {
        tags: {
            type: Array,
            default: []
        },
        isDisplay: {
            type: Boolean,
            default: false
        }
    },
    data: vm =>({
        items: []
    }),
    created(){
        this.tags.forEach( tag => {
            const obj = Object.assign({selected: false}, tag)
            this.items.push(obj)
        })
    },
    watch: {
        tags: {
            handler (newVal, oldVal) {
                this.tags.forEach( tag => {
                    const obj = Object.assign({selected: false}, tag)
                    this.items.push(obj)
                })
            },
            deep: true //是否深度监听
        }
    },
    methods: {
        selectTag(item){
            if(this.isDisplay){
                return
            }
            if(item.selected){
                return
            }
            this.items.forEach( obj => {
                obj.selected = false
            })
            item.selected = true
            this.$emit('chooseTag', item.name)
        }
    }
}
</script>
<style scoped>
.depend-tag {
  cursor: pointer;
  margin: 5px 0px 10px 25px;
}
</style>